import { Injectable } from '@angular/core';
import {CustomHttp} from '../customhttp';
import {AppConstants} from '../app.constants';
import {Headers, RequestOptions, Response} from '@angular/http';
import * as xml2js from 'xml2js';
import {PilotGarageBayiModel} from '../model/pilotGarageBayi.model';

@Injectable()
export class PilotGarageService {

  constructor(public http: CustomHttp) { }

  public getBayiList() {
    let apiURL = AppConstants.API_ENDPOINT + '/pilot-garage';
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});
    return this.http.get(apiURL, options);
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/pilot-garage.service.ts